<template>
    <div class="container">
        <b-row>
            <b-container>
                <h3 class="text-center py-2" v-if="!generado">
                    <b><i>{{ f_titulo() }}</i></b>
                </h3>

                <h5 class="text-center py-2">
                    <b-row class="mb-4 justify-content-center align-items-center text-lg">
                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.codReporte }}:</b></label>
                            <select v-model="dialogReportes" @click="isEmpty = true;"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="(reporte, idx) in reportes" :key="'reporte-' + idx"
                                    :value="reporte.codigo">
                                    {{ reporte.nombre }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.fecha_reporte }}:</b></label>
                            <select v-model="dialogFechas" @click="isEmpty = true;"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="(item, idx) in fechas" :key="'fecha-' + idx" :value="item.fecha">
                                    {{ item.fecha }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4 justify-content-center align-items-center">
                        <b-col md="auto" class="text-center">
                            <b-button v-if="dialogFechas && dialogReportes" variant="primary" @click="f_generar(0)"
                                class="btn-lg px-5 mx-2 fs-5">
                                <b><i>{{ labels.generar }}</i></b>
                            </b-button>
                            <b-button v-if="dialogFechas && dialogReportes" variant="outline-primary"
                                @click="f_generar(1)" class="btn-lg px-5 mx-2 fs-5">
                                <b><i>{{ labels.consultar }}</i></b>
                            </b-button>
                            <b-button v-if="dialogFechas && dialogReportes" variant="outline-primary"
                                @click="f_generar(2)" class="btn-lg px-5 mx-2 fs-5">
                                <b><i>{{ labels.modificar }}</i></b>
                            </b-button>
                        </b-col>
                    </b-row>
                </h5>
            </b-container>
        </b-row>

        <b-row v-if="isLoading">
            <b-container class="text-center py-5">
                <b-col md="12">
                    <div class="loading-spinner mb-3">
                        <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                    </div>
                    <h4 class="text-primary">
                        <b><i>Cargando información...</i></b>
                    </h4>
                </b-col>
            </b-container>
        </b-row>

        <b-row v-if="!isLoading && !isEmpty">
            <b-container class="pb-5">
                <md-table v-model="eliminaciones" md-card md-fixed-header
                    :class="{ 'balance-table': true, 'principal-table': true }" key="principal-table">

                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title"><b><i>{{ f_titulo() }}</i></b></h1>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }"
                        :class="{ 'clickable-row': true, 'selected-row': selectedRow === item.secuencia }"
                        @click="handleRowClick(item)">
                        <md-table-cell :md-label="labels.secuencia" class="text-center border number-cell">
                            {{ item.secuencia }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.tipo_ajuste" class="text-left border descripcion-cell">
                            {{ f_tipo_ajuste(item.tipo_ajuste) }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.origen_nombre" class="text-left border descripcion-cell">
                            {{ item.origen_nombre }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.tipo_origen" class="text-left border descripcion-cell">
                            {{ item.tipo_origen }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.destino_nombre" class="text-left border descripcion-cell">
                            {{ item.destino_nombre }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.tipo_destino" class="text-left border descripcion-cell">
                            {{ item.tipo_destino }}
                        </md-table-cell>
                        <md-table-cell v-if="opcion == 0" :md-label="labels.generar"
                            class="text-center border action-cell">
                            <md-button @click.stop="f_genere_item(item.secuencia)"
                                class="md-raised md-primary btn-edit">
                                <md-icon>check</md-icon>
                            </md-button>
                        </md-table-cell>
                    </md-table-row>
                </md-table>

                <div class="text-center mt-3" v-if="selectedRow">
                    <div class="alert alert-info d-inline-block">
                        <strong>Fila seleccionada:</strong> Secuencia {{ selectedRow }}.
                        Haga clic en otra fila para cambiar la selección.
                    </div>
                </div>
            </b-container>
        </b-row>

        <b-row>
            <b-container v-if="!isEmpty && muestra">
                <div class="row mt-12">
                    <div class="col-md-12">
                        <Origen v-if="listOrigen.length > 0" @envOrigen="recOrigen" :infocodReporte="dialogReportes" :infoOrigen="listOrigen"
                            :infoOpcion="opcion" :infoEmpresa="empresa_origen" :infoIdCompania="idCompania"
                            :infoEmpresa1="empresa_destino" :infoIdCompania1="idCompania1" :infoTipoAjuste="tipo_ajuste"
                            :infoTipo="tipo_origen" :infoVigencia="vigencia" :infoSecuencia="secuencia"
                            @cierraDetalle="cierraDetalle" @ajusteGuardado="refrescarDatos" />
                    </div>
                    <div class="col-md-12">
                        <Destino v-if="listDestino.length > 0" @envDestino="recDestino" :infocodReporte="dialogReportes" :infoDestino="listDestino"
                            :infoOpcion="opcion" :infoEmpresa="empresa_destino" :infoTipo="tipo_destino"
                            :infoVigencia="vigencia" :infoSecuencia="secuencia" @cierraDetalle="cierraDetalle" @ajusteGuardado="refrescarDatos" />
                    </div>
                </div>
            </b-container>

            <b-container v-if="!isLoading && isEmpty">
                <b-col md="2" class="mx-auto">
                    <div class="success-svg mb-4" :class="{ active: isEmpty }">
                        <img src="../../assets/imgs/file-2.svg" alt="warning" />
                    </div>
                </b-col>
                <b-col md="12" class="justify-content-around">
                    <span id="message" v-if="isEmpty">{{ labels.empty }}</span>
                </b-col>
            </b-container>
        </b-row>
    </div>
</template>

<script>
import Origen from "./EliminaOrigen.vue"
import Destino from "./EliminaDestino.vue"
import Balance from "@/services/BalanceNiif"

export default {
  name: "BalanceNiif",

  data: () => ({
    rolSeleccionado: {},
    myOptions: [],
    rolSelected: '',
    showDialog: false,
    showDialogEdit: false,
    dialogItem: {},
    eliminaciones: [],
    listOrigen: [],
    listDestino: [],
    empresa_origen: '',
    tipo_ajuste: '',
    tipo_origen: '',
    idCompania: '',
    empresa_destino: '',
    idCompania1: '',
    tipo_destino: '',
    searched: [],
    isEmpty: true,
    isLoading: false,
    error: false,
    formEdit: {
      nameBalance: '',
      acronym: '',
      url: ''
    },
    moneda : "",
    vigencia:'',
    opcion: '',
    modifica: 0,
    muestra: false,
    directo:false,
    indirecto:false,
    companias : [],
    dialogCompanias : [],
    fechas : [],
    reportes : [],
    dialogFechas : '',
    dialogReportes : '',
    columnas: 0,
    titulo_columna: [],
    empresa: 0,
    generado: false,
    nivel: 1,
    titulo: 3,
    valor_ajustar_actual: 0,
    valor_ajustar_funcional1: 0,
    selectedRow: null
  }),

  components:{
    Origen,
    Destino
  },

  computed:{
    labels(){
      if (this.$store.state._language == "es-ES") {
        return {
          title: "BALANCE",
          codigo: "Codigo",
          descripcion: "Descripcion",
          saldo_anterior: "Saldo Periodo Anterior",
          saldo_actual: "Saldo Periodo Actual",
          diferencia: "Diferencia",
          monto: "Monto",
          empty: "Sin Seleccion",
          notFoundMessage: "Sin Informacion",
          generar : "Generar",
          modificar : "Modificar",
          consultar : "Consultar",
          ajustes : "Ajustes",
          consolidado : "Consolidado",
          moneda : "Moneda",
          fecha_reporte : "Vigencia",
          secuencia : "Secuencia",
          origen_nombre : "Empresa",
          tipo_ajuste : "Tipo Ajuste",
          tipo_origen : "Tipo",
          destino_nombre : "Empresa",
          tipo_destino : "Tipo",
          opcion : "Opcion",
          codReporte : "Reporte",
        }
      }else {
        return {
          title: "NIIF CHECKING BALANCE",
          codigo: "Code",
          descripcion: "Description",
          saldo_anterior: "Previous Period Balance",
          saldo_actual: "Current Period Balance",
          diferencia: "Difference",
          monto: "Amount",
          compania: "Company",
          empty: "Without Information",
          notFoundMessage: "Without Information",
          generar : "Trigger",
          modificar : "Modify",
          consultar : "Consult",
          ajustes : "Settings",
          consolidado : "Consolidated",
          moneda : "Currency",
          fecha_reporte : "Effective Date",
          secuencia : "Sequence",
          origen_nombre : "Company",
          tipo_ajuste : "Setting type",
          tipo_origen : "Class",
          destino_nombre : "Company",
          tipo_destino : "Class",
          opcion : "Choice",
          codReporte : "Report",
        }
      }
    }
  },

  methods: {
    f_titulo() {
        let titulo = ""
        let tituloEN = ""
        let tituloConsolidado = ""
        titulo = "ELIMINACION DE SALDOS "
        tituloEN = "ELIMINATION OF ACCOUTING ITEMS"
        if	(this.$store.state._language == "es-ES") {
            tituloConsolidado = titulo
        } else	{
            tituloConsolidado = tituloEN
        }
        switch ( this.titulo ) {
        case	0 : tituloConsolidado = tituloConsolidado+
                " ["+this.labels.generar.toUpperCase()+" ]";break
        case	1 : tituloConsolidado = tituloConsolidado+
                " ["+this.labels.consultar.toUpperCase()+" ]";break
        case	2 : tituloConsolidado = tituloConsolidado
                +" ["+this.labels.modificar.toUpperCase()+" ]";break
        }
        return tituloConsolidado
      },

      refrescarDatos() {
          if (this.secuencia && this.vigencia) {
              this.recOrigen();
              this.recDestino();
          }
      },

    handleRowClick(item) {
        this.selectedRow = item.secuencia;
        this.f_muestra(item.secuencia, this.opcion === 2 ? 1 : 0);
    },

    f_muestra(secuencia,modifica) {
        this.muestra=true
        this.secuencia=secuencia
        let objEliminaciones = this.eliminaciones.find(
            (obj) => obj.secuencia === secuencia)
        this.empresa_origen=objEliminaciones.origen_nombre
        this.idCompania=objEliminaciones.origen
        this.tipo_ajuste=objEliminaciones.tipo_ajuste
        this.tipo_origen=objEliminaciones.tipo_origen
        this.empresa_destino=objEliminaciones.destino_nombre
        this.idCompania1=objEliminaciones.destino
        this.tipo_destino=objEliminaciones.tipo_destino
        this.modifica=modifica
        this.recOrigen()
        this.recDestino()
    },

    f_genere_item(secuencia) {
        Balance.genereEliminaciones(this.dialogReportes,this.vigencia,secuencia)
        .then((result) => {
            console.log(result)
            this.$toast.success("Eliminacion Generada")
        })
        .catch(() => {
            this.$toast.error("Problema al generar eliminacion")
        });
    },

    f_generar(opcion) {
        this.opcion=''
        if	(this.dialogFechas && this.dialogReportes) {
            this.muestra=false
            this.vigencia=this.dialogFechas
            this.isEmpty=true
            this.generado=false
            this.isLoading = true;
            this.selectedRow = null;
            
            Balance.getEliminaciones(this.dialogReportes,this.vigencia,opcion)
            .then((result) => {
                this.eliminaciones = result.data.eliminaciones[0];
                this.searched = this.eliminaciones;
                if (this.eliminaciones.length != 0) {
                    this.isEmpty = false;
                    this.generado=true
                    this.opcion=opcion
                }
                this.isLoading = false;
            })
            .catch(() => {
                this.error = true;
                this.isLoading = false;
            });
        }
    },

    seleccionaCompania() {
        this.isEmpty=true;
        let buscaMoneda = this.companias.filter((item) =>
            item.id==this.dialogCompanias)
            this.moneda = buscaMoneda[0].acronimo
    },

    formato(numero) {
        return  new Intl.NumberFormat('en-US',{ maximumFractionDigits: 0}).format(numero)
    },

    recOrigen(){
        Balance.getEliminaOrigen(this.vigencia,this.secuencia, this.dialogReportes)
        .then((res) => {
            this.listOrigen = res.data.listEliminaOrigen[0]
        })
        .catch((err) => {
            console.log(err)
        })
    },

    recDestino(){
        Balance.getEliminaDestino(this.vigencia,this.secuencia, this.dialogReportes)
        .then((res) => {
            this.listDestino = res.data.listEliminaDestino[0]
        })
        .catch((err) => {
            console.log(err)
        })
    },

    cierraDetalle() {
        this.muestra = false
        this.selectedRow = null;
    },

    f_tipo_ajuste(tipo) {
        let tipo_ajuste = ""
        switch (tipo) {
        case	1 : tipo_ajuste = "Interes no Controlante";break;
        case	2 : tipo_ajuste = "Eliminacion en Inversion";break;
        case	3 : tipo_ajuste = "Eliminacion Saldos Reciprocos";break;
        default	: tipo_ajuste = "Tipo sin identificar";break;
        }
        return tipo_ajuste
    }
  },
    
  mounted() {
    this.isLoading = true;
    
    Balance.getFechas()
    .then ((result) => {
        this.fechas = result.data.fechas
        this.dialogFechas = ''
        this.isLoading = false;
    })
    .catch(() => {
        this.error = true
        this.isLoading = false;
    });

    Balance.getReportes()
    .then ((result) => {
        this.reportes = result.data.reportes
    })
    .catch(() => {
        this.error = true
    });
  }
};
</script>

<style scoped>
.balance-table {
    font-size: 14px;
    width: 100% !important;
}

.balance-table>>>.md-table-head {
    padding: 6px 4px !important;
}

.balance-table>>>.md-table-cell {
    padding: 6px 4px !important;
    min-width: auto !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    line-height: 1.2 !important;
}

.principal-table>>>.md-table {
    width: 100% !important;
    table-layout: auto !important;
}

.principal-table>>>.md-table-cell {
    width: auto !important;
    max-width: none !important;
}

.balance-table>>>.md-table-toolbar {
    min-height: 50px !important;
    padding: 6px 12px !important;
}

.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s;
}

.clickable-row:hover {
    background-color: #f5f5f5 !important;
}

.selected-row {
    background-color: #e8f4fd !important;
    border-left: 3px solid #2c5f7a !important;
}

.border {
    border: 1px solid #dee2e6 !important;
}

.principal-table>>>.md-table-row {
    transition: all 0.2s ease;
}

.principal-table>>>.md-table-row:hover {
    background-color: #f5f5f5 !important;
}

.btn-edit {
    min-width: 40px !important;
    height: 32px !important;
    margin: 0 !important;
    padding: 0 !important;
}

.btn-edit .md-icon {
    font-size: 16px !important;
}

.principal-table >>> .md-table-cell {
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    max-width: 200px !important;
}
</style>

<style src="../main.css"></style>
